import {BlockJobNetwork} from "./BlockJobNetwork";
import {BlockJobsLoop} from "./BlockJobsLoop";

export const PluginCompany = {
	init(): void {
		// block: wv-job-network
		const jobNetworkBlocks = document.querySelectorAll( '.wv-block--job-network' ) as NodeListOf<HTMLElement>;
		jobNetworkBlocks.forEach( ( block: HTMLElement ): void => {
			BlockJobNetwork( block );
		} );

		// block: wv-jobs-loop
		const jobsLoopBlocks = document.querySelectorAll( '.wv-block--jobs-loop' ) as NodeListOf<HTMLElement>;
		jobsLoopBlocks.forEach( ( block: HTMLElement ): void => {
			BlockJobsLoop( block );
		} );
	}
}
